// extracted by mini-css-extract-plugin
export var container = "CourseList-module--container--94ec3";
export var courseImage = "CourseList-module--courseImage--5b6b0";
export var courseImageContainer = "CourseList-module--courseImageContainer--8610d";
export var courseItem = "CourseList-module--courseItem--3f61c";
export var courseName = "CourseList-module--courseName--b2078";
export var textItemCount = "CourseList-module--textItemCount--f403b";